// MM: Diagnose Teil 2 - Geometrie des Filter-Dialogs
// Aufruf: Kollektionsseite mit ?mmdebug=2
(function () {
  if (new URLSearchParams(location.search).get('mmdebug') !== '2') return;

  function run() {
    var lines = [];
    function add(k, v) { lines.push('<b>' + k + ':</b> ' + v); }

    var host = document.getElementById('filters-drawer');
    if (!host) { add('Fehler', '#filters-drawer fehlt'); show(lines); return; }

    var dlg = host.matches('dialog') ? host : host.querySelector('dialog');
    if (!dlg) { add('Fehler', 'kein dialog'); show(lines); return; }

    try {
      if (typeof host.showDialog === 'function') host.showDialog();
      else dlg.showModal();
    } catch (e) { add('Oeffnen', 'Fehler: ' + e.message); }

    setTimeout(function () {
      var r = dlg.getBoundingClientRect();
      var cs = getComputedStyle(dlg);

      add('open', dlg.open);
      add('Position', Math.round(r.left) + ',' + Math.round(r.top));
      add('Groesse', Math.round(r.width) + 'x' + Math.round(r.height));
      add('Viewport', window.innerWidth + 'x' + window.innerHeight);
      add('sichtbar', (r.width > 0 && r.height > 0 && r.right > 0 && r.left < window.innerWidth && r.bottom > 0 && r.top < window.innerHeight) ? 'JA' : 'NEIN');
      add('display', cs.display);
      add('visibility', cs.visibility);
      add('opacity', cs.opacity);
      add('position', cs.position);
      add('transform', cs.transform === 'none' ? 'none' : 'gesetzt');
      add('zIndex', cs.zIndex);

      // Klassiker: Vorfahre mit transform/filter/backdrop-filter kapert fixed-Elemente
      var culprits = [];
      var node = dlg.parentElement;
      while (node && node !== document.documentElement) {
        var s = getComputedStyle(node);
        var bad = [];
        if (s.transform && s.transform !== 'none') bad.push('transform');
        if (s.filter && s.filter !== 'none') bad.push('filter');
        if (s.backdropFilter && s.backdropFilter !== 'none') bad.push('backdrop-filter');
        if (s.perspective && s.perspective !== 'none') bad.push('perspective');
        if (s.contain && s.contain !== 'none') bad.push('contain');
        if (s.willChange && s.willChange !== 'auto') bad.push('will-change:' + s.willChange);
        if (s.overflow !== 'visible') bad.push('overflow:' + s.overflow);
        if (bad.length) {
          culprits.push((node.tagName.toLowerCase()) + (node.className && typeof node.className === 'string' ? '.' + node.className.trim().split(/\s+/).slice(0, 2).join('.') : '') + ' [' + bad.join(', ') + ']');
        }
        node = node.parentElement;
      }
      add('Vorfahren', culprits.length ? culprits.join('<br>&nbsp;&nbsp;') : 'unauffaellig');

      show(lines);
    }, 500);
  }

  function show(lines) {
    var box = document.createElement('div');
    box.id = 'mm-debug';
    box.innerHTML = lines.join('<br>');
    box.addEventListener('click', function () { box.remove(); });
    document.body.appendChild(box);
  }

  if (document.readyState === 'complete') setTimeout(run, 1200);
  else window.addEventListener('load', function () { setTimeout(run, 1200); });
})();
